
import React, { useEffect, useState } from "react";
import { Col, Modal, Row, Form } from "react-bootstrap";
// import { Form } from 'react-router-dom';
import CloseSharpIcon from "@mui/icons-material/CloseSharp";
import { useParams } from "react-router-dom";
import toast from "react-hot-toast";
import axios from "../../API/axios";
import Flatpickr from "react-flatpickr";
import moment from "moment";
import ErrorToast from "../ErrorToast";
import WarningToast from "../WarningToast";
import SuccessToast from "../SuccessToast";
import { customStyles } from "../../selectStyles";
import { debounce } from "lodash";
import Select from "react-select";
import CreatableSelect from "react-select/creatable";
import { useTranslation } from "react-i18next";



const CCVExpRoleUpdate = ({
    getUserCcv,
    handleCloseEditExperienceRole,
    showEditExperienceRole,
    ExperienceData,
    experienceRoleData,
}) => {
    console.log("experienceRoleData", experienceRoleData);
    const sessionId = localStorage.getItem("sessionId");
    const userType = localStorage.getItem("userType");
    const { t } = useTranslation();
    const language = localStorage.getItem("Lang");
    const [achievement, setAchievement] = useState("");
    const [achievementtDate, setAchievementDate] = useState("");
    const [display, setDisplay] = useState(false);
    const [toastMessage, setToastMessage] = useState("");
    const [showToast, setShowToast] = useState(false);

    const [warningToastMessage, setWarningToastMessage] = useState("");
    const [showWarningToast, setShowWarningToast] = useState(false);

    const [ErrorToastMessage, setErrorToastMessage] = useState("");
    const [showErrorToast, setShowErrorToast] = useState(false);
    const handleSubmit = async (e) => {
        e.preventDefault();
        setDisplay(true);
        const body = {
            deviceType: "Web",
            sessionId: sessionId,
            rsmExpId: ExperienceData.rsmExpId,
            // "id": experienceRoleData.expAchvmntId,
            id: experienceRoleData.id,
            role: achievement,
        };
        const body1 = {
            deviceType: "Web",
            sessionId: sessionId,
            userExpId: ExperienceData.userExprncId,
            // "id": experienceRoleData.expAchvmntId,
            userExpRoleId: experienceRoleData.id,
            role: achievement,
            langKey: language === "en" ? "" : language,
        };
        console.log("body", body);
        if (achievement === "") {
            toast.error(t("modals.Please fill all the required fields"));
        } else {
            const apiUrl = ExperienceData.isSyncedWithUserData
                ? `UserData/UpdateExperienceRole`
                : `ResumeData/UpdateRsmExperienceRole`;

            const payload = ExperienceData.isSyncedWithUserData ? body1 : body;

            try {
                const res = await axios.put(
                    apiUrl, payload
                );
                // toast.success(res.data.message);
                setToastMessage(res.data.message);
                setShowToast(true);
                handleCloseEditExperienceRole();
                getUserCcv();
                setDisplay(false);
            } catch (error) {
                if (error.response && error.response.status === 404) {
                    setWarningToastMessage(error.response.data.message);
                    setShowWarningToast(true);
                } else {
                    setErrorToastMessage(error.response.data.message);
                    setShowErrorToast(true);
                }
            }
        }
    };

    useEffect(() => {
        if (experienceRoleData) {
            setAchievement(experienceRoleData.role);
              setShowInputInsteadOfDropdown(true);
        }
    }, [experienceRoleData]);


    // useEffect(() => {
    //     if (showEditExperienceRole) {
    //         document.body.style.overflow = 'hidden';
    //         document.documentElement.style.overflow = 'hidden';
    //         document.body.classList.add('modal-open'); // When a modal opens
    //     } else {
    //         document.body.style.overflow = 'unset';
    //         document.documentElement.style.overflow = '';
    //         document.body.classList.remove('modal-open'); // When a modal closes
    //     }
    // }, [showEditExperienceRole]);
     const [pageP, setPageP] = useState(0);
  const [typedprofile, setTypedprofile] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [optionsP, setOptionsP] = useState([]);
  const [totalPagesProfile, setTotalPagesProfile] = useState(0);

  const logValue1 = debounce((typedprofile) => {
    setTypedprofile(typedprofile);
  }, 250);

   const addOptionsprofile = () => {
    setIsLoading(true);
     const data = {
        pageNumber: pageP + 1,
        pageSize: 100,
        deviceType: "Web",
     }
    axios
      .post(
        `Master/GetExprncRolesDDL?search=${typedprofile}&LangKey=${language}`, data
      )
      .then((response) => {
        console.log("response.........",response );
        const data = response?.data?.responseData?.allData;
        // Check if data is an array
        if (Array.isArray(data)) {
          const mappedData = data.map((item,index) => ({
            label: item,
            value: item,
          }));
          console.log("mappedData==>",mappedData)
          setOptionsP((prevOptions) => [...prevOptions, ...mappedData]);
        } else {
          console.error("Expected data to be an array, but got:", data);
        }

        setPageP((prevPage) => prevPage + 1);
        setIsLoading(false);
        setTotalPagesProfile(response?.data?.paging?.totalPages || 0);
      })
      .catch((error) => {
        console.error("Error fetching options:", error);
        setIsLoading(false);
      });
  }; 
  const handleOpenProfle = () => {
    setPageP(1);
  };

  const handleChangeProfile = (value) => {
    if (value=== null) { 
      setAchievement(null);
    } else {
      setAchievement(value.label);
    } 
  };

  const handleInputChangeProfile = (typedprofile) => {
    logValue1(typedprofile);
    if (!typedprofile) setPageP(0);
  };

  const handleMenuScrollToBottomProfile = () => {
    if (pageP < totalPagesProfile) {
      addOptionsprofile();
    }
  };

  useEffect(() => {
    if (typedprofile) {
    addOptionsprofile();
    }
  }, [typedprofile]);

  //************************ experience End  ************************//


  const [showInputInsteadOfDropdown, setShowInputInsteadOfDropdown] = useState(false);

    return (
        <>
            {showEditExperienceRole && (
                <div
                    className="modal fade show modal-lg"
                    tabIndex="-1"
                    role="dialog"
                    style={{ display: "block" }}
                >
                    <div className="modal-dialog modal-dialog-centered" role="document">
                        <div className="modal-content">
                            <div className="setting-header d-flex justify-content-between align-items-center">
                                <h6> {t("modals.Update Responsibilities")}</h6>
                                <CloseSharpIcon
                                    className="material-symbols-sharp me-3 pointer"
                                    onClick={handleCloseEditExperienceRole}
                                />
                            </div>
                            <Form>
                                <div className="row modal-p settings CreateCompany">
                                    <Row>
                                        <Col md={12}>
                                            {/* <Form.Group controlId="grade">
                                                <Form.Label className="class-type">
                                                    Responsibilities{" "}
                                                    <span style={{ color: "red" }} className="ms-2">
                                                        *
                                                    </span>
                                                </Form.Label> 
                                                 
                                                {achievement && showInputInsteadOfDropdown ? (
                                                <Form.Control
                                                    type="text"
                                                    className="Dark-Input-from-group"
                                                    value={achievement}
                                                    onChange={(e) => setAchievement(e.target.value)}
                                                    onBlur={() => setShowInputInsteadOfDropdown(false)}
                                                    autoFocus
                                                />
                                                ) : (
                                                <CreatableSelect
                                                    defaultValue={achievement}
                                                    options={optionsP}
                                                    styles={customStyles}
                                                    placeholder={"Search and Select Responsibilities"}
                                                    onOpen={handleOpenProfle}
                                                    onChange={(selectedOption) => {
                                                    if (selectedOption) {
                                                        setAchievement(selectedOption.value);
                                                        setShowInputInsteadOfDropdown(true); // switch to input for editing
                                                    } else {
                                                        setAchievement("");
                                                    }
                                                    }}
                                                    onMenuScrollToBottom={handleMenuScrollToBottomProfile}
                                                    onInputChange={handleInputChangeProfile}
                                                    isClearable
                                                    isValidNewOption={(inputValue, _, selectOptions) =>
                                                    !!inputValue && !selectOptions.some(option => option.label === inputValue)
                                                    }
                                                    onCreateOption={(inputValue) => {
                                                    const newOption = { label: inputValue, value: inputValue };
                                                    setOptionsP((prev) => [...prev, newOption]);
                                                    setAchievement(inputValue);
                                                    setShowInputInsteadOfDropdown(true); // allow further edit
                                                    }}
                                                    value={achievement ? { label: achievement, value: achievement } : null}
                                                    className={display && achievement === "" ? "is-invalid" : ""}
                                                />
                                                )}

                                                {display && !achievement && (
                                                <span className="error_msg_lbl">Add Responsibilities</span>
                                                )}

                                            </Form.Group> */}

                                            <Form.Group controlId="grade">
                                                <Form.Label className="class-type">
                                                    Responsibilities <span style={{ color: "red" }} className="ms-2">*</span>
                                                </Form.Label>

                                                {achievement && showInputInsteadOfDropdown ? (
                                                    <Form.Control
                                                    type="text"
                                                    className="Dark-Input-from-group"
                                                    value={achievement}
                                                    onChange={(e) => setAchievement(e.target.value)}
                                                    onBlur={() => setShowInputInsteadOfDropdown(false)} // Optional: revert to select on blur
                                                    autoFocus
                                                    />
                                                ) : (
                                                    <CreatableSelect
                                                    defaultValue={achievement}
                                                    options={optionsP}
                                                    styles={customStyles}
                                                    placeholder={"Search and Select Responsibilities"}
                                                    onOpen={handleOpenProfle}
                                                    onChange={(selectedOption) => {
                                                        if (selectedOption) {
                                                        setAchievement(selectedOption.value);
                                                        setShowInputInsteadOfDropdown(true); // show input for editing
                                                        } else {
                                                        setAchievement("");
                                                        }
                                                    }}
                                                    onMenuScrollToBottom={handleMenuScrollToBottomProfile}
                                                    onInputChange={handleInputChangeProfile}
                                                    isClearable
                                                    isValidNewOption={(inputValue, _, selectOptions) =>
                                                        !!inputValue && !selectOptions.some((option) => option.label === inputValue)
                                                    }
                                                    onCreateOption={(inputValue) => {
                                                        const newOption = { label: inputValue, value: inputValue };
                                                        setOptionsP((prev) => [...prev, newOption]);
                                                        setAchievement(inputValue);
                                                        setShowInputInsteadOfDropdown(true);
                                                    }}
                                                    value={achievement ? { label: achievement, value: achievement } : null}
                                                    className={display && achievement === "" ? "is-invalid" : ""}
                                                    />
                                                )}

                                                {display && !achievement && (
                                                    <span className="error_msg_lbl">Add Responsibilities</span>
                                                )}
                                                </Form.Group>

                                        </Col>

                                    </Row>

                                    <div className="text-end mt-4">
                                        <button
                                            type="button"
                                            className="closebtn me-2"
                                            onClick={handleCloseEditExperienceRole}
                                            style={{ width: "70px" }}
                                        >
                                            {t("User Profile.Close")}
                                        </button>
                                        <button
                                            type="button"
                                            className="mainBtn1"
                                            onClick={handleSubmit}
                                            style={{ width: "107px" }}
                                        >
                                             {t("User Profile.Submit")}
                                        </button>
                                    </div>
                                </div>
                            </Form>
                        </div>
                    </div>
                </div>
            )}
            <SuccessToast
                show={showToast}
                message={toastMessage}
                onClose={() => setShowToast(false)}
            />

            <WarningToast
                show={showWarningToast}
                message={warningToastMessage}
                onClose={() => setShowWarningToast(false)}
            />

            <ErrorToast
                show={showErrorToast}
                message={ErrorToastMessage}
                onClose={() => setShowErrorToast(false)}
            />
        </>

    );
};

export default CCVExpRoleUpdate;
